import { Component } from '@angular/core';

import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';

@Component({
    selector: 'finder-virtual-queue-modal',
    templateUrl: './virtual-queue-modal.component.html',
    styleUrls: ['./virtual-queue-modal.component.scss'],
})
export class VirtualQueueModalComponent implements ModalChildComponent {
    data: any;
    parentComponent: ModalComponent;
}
